export default "__VITE_ASSET__CR$xrgnf__"